<template>
    <el-dialog
        :title="`打印日志(发车单号：${dispatchNo})`"
        :visible="true"
        width="80%"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose">
        <div class="print-log-wrapper" v-loading="loading">
            <div class="orderNo-wrapper">
                <span class="title">单号</span>
                <ul class="orderNo-list">
                    <li
                        v-for="(item, index) in orderNoList"
                        :key="index"
                        @click="handleClick(item, index)"
                        :class="['orderNo-item', { 'active': clickIndex === index}]"
                    >
                        <el-tooltip class="item" effect="dark" :content="item " placement="right">
                            <p>{{ item }}</p>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
            <el-table
                border
                height="400px"
                max-height="500px"
                style="width:100%"
                :data="printLogList"
                @cell-dblclick="cellDblClick"
                class="table-wrapper"
            >
                <el-table-column prop="createTime" label="打印时间" min-width="150px"></el-table-column>
                <el-table-column label="打印模板" min-width="130px">
                    <template v-slot="scope">
                        <el-tooltip class="item" effect="dark" :content="`打印模板编码:${scope.row.reportNo}`" placement="top">
                            <p @dblclick.stop="handleDbClick($event)">{{ scope.row.reportName }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="createUserCode" label="打印人账号" min-width="100px"></el-table-column>
                <el-table-column prop="createUserName" label="打印人姓名" min-width="100px"></el-table-column>
                <el-table-column prop="printCount" min-width="90px">
                    <template slot="header">
                        <span>打印次数</span>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content">该发车单打印该类型模板的次数，不是该发车单的全部单据类型汇总打印次数</div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="printOrder" min-width="200px" :show-overflow-tooltip="true">
                    <template slot="header">
                        <span>打印订单</span>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content">每次打印具体涉及哪些订单以实际打印效果为准</div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="reasonName" label="补打原因" min-width="90px"></el-table-column>
                <el-table-column prop="remark" label="补打备注" min-width="150px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="driverPrintName" label="打印类型" min-width="100px"></el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { queryCustomerByDispatchNo, queryPrintDetail } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'PrintLog',
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        printOrder: {
            type: String
        }
    },
    data () {
        return {
            loading: false,
            dispatchNo: '',
            clickIndex: 0,
            orderNoList: [],
            printLogList: [],
            dictData: {}
        };
    },
    async mounted () {
        this.dispatchNo = this.componentsData.dispatchNo;
        await this.getDicData();
        await this.initSearch();
    },
    methods: {
        initSearch () {
            this.loading = true;
            const printDetailParam = this.printOrder ? { billsNo: this.dispatchNo, printOrder: this.printOrder }
                : { billsNo: this.dispatchNo };
            Promise.all([
                this.getOrderNoList({ dispatchNo: this.dispatchNo }),
                this.queryPrintDetail(printDetailParam)
            ])
                .then()
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getOrderNoList (data) {
            queryCustomerByDispatchNo(data).then(res => {
                if (res && +res.code === 0) {
                    if (res.data && Array.isArray(res.data)) {
                        this.orderNoList = [this.dispatchNo].concat(res.data);
                        this.$nextTick(() => {
                            this.clickIndex = this.printOrder && (this.orderNoList.findIndex(v => v === this.printOrder) !== -1)
                                ? this.orderNoList.findIndex(v => v === this.printOrder) : 0;
                        });
                    } else {
                        this.orderNoList = [this.dispatchNo];
                    }
                }
            }).catch(() => { });
        },
        queryPrintDetail (data) {
            queryPrintDetail(data).then(res => {
                if (res && +res.code === 0) {
                    this.printLogList = this.formatPrintLog(res.data || []);
                }
            }).catch(() => { });
        },
        formatPrintLog (data) {
            if (!data.length) return [];
            data.forEach(item => {
                item.driverPrintName = this.dictData.DRIVER_PRINT_TYPE[item.driverPrint] || item.driverPrint;
                item.reasonName = this.dictData.REPEAT_PRINT_REASON[item.reason] || item.reason;
                item.printOrder = item.driverPrint === 0 ? '普通打印不支持订单维度打印，具体打印了哪些订单以实际效果为准' : item.printOrder;
            });
            return data;
        },
        handleClick (item, index) {
            this.clickIndex = index;
            this.printLogList = [];
            if (this.clickIndex === 0) {
                this.queryPrintDetail({ billsNo: this.dispatchNo });
            } else {
                this.queryPrintDetail({ billsNo: this.dispatchNo, printOrder: item });
            }
        },
        handleDbClick (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && this.copyToClip(value);
        },
        copyToClip(txt) {
            var input = document.createElement('input');
            input.setAttribute('value', txt);
            document.body.appendChild(input);
            // 选择对象
            input.select();
            // 执行浏览器复制命令
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        cellDblClick (row, column, cell, event) {
            if (row[column.property] === '' || row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            this.copyToClip(value);
        },
        handleClose () {
            this.$emit('update:isShowPrintLogDialog', false);
        },
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'REPEAT_PRINT_REASON,DRIVER_PRINT_TYPE'
            );
            this.dictData = dict.data;
        }
    }
};
</script>

<style lang="less">
.print-log-wrapper {
    display: flex;
    .orderNo-wrapper {
        max-height: 400px;
        line-height: 33px;
        font-size:14px;
        text-align: center;
        color:#333;
        .title {
            line-height: 35px;
            width: 100%;
            display: inline-block;
            background-color: #F6F6F7;
        }
        .orderNo-list {
            width: 200px;
            overflow: auto;
            height: 365px;
            background: #fff;
            color: #333;
            .orderNo-item{
                cursor: pointer;
                border-left: 1px solid #EBEEF5;
                border-bottom: 1px solid #EBEEF5;
                white-space: nowrap; /*文字不换行，为了让文字溢出*/
                overflow: hidden; /*隐藏滚动条*/
                text-overflow: ellipsis; /*溢出部分显示为“...”*/
            }
            .active {
                background: #e1e9ef;
            }
        }
    }
    .item {
        margin: 0;
    }
}
</style>
